(function () {
    'use strict';

    angular.module('filter')
        .service('FilterService', function () {
            var defaultStatusFilter = {
                'parameter': 'defectStatus',
                'operand': 'IN',
                'operation': 'AND',
                'valuesArray': ['NEW', 'READ', 'SOLVING', 'SEEN_BY_LAKD'],
                'type': 'status',
                'parameterConfig': { 'operands': ['=', '<>', 'IN'] }
            };
            var defaultWorkTypeFilter = {
                'parameter': 'workType',
                'operand': '<>',
                'operation': 'AND',
                'value': 'INFORMING_LAKD',
                'type': 'workType',
                'parameterConfig': { 'operands': ['=', '<>'] }
            }
            return {
                filters: [defaultStatusFilter, defaultWorkTypeFilter],
                currentFilters: [],
            };
        });
})();
